import { useMutation, useQueryClient } from "@tanstack/react-query";

import { enrollmentRequest } from "@/apiQueries/multisigEnrollment/multisigEnrollmentRequest";
import {
  MULTISIG_ENROLLMENT_QUERY_KEY,
  MULTISIG_ENROLLMENT_URL,
} from "@/apiQueries/multisigEnrollment/useMultisigEnrollment";

import type { EnrollmentError } from "@/helpers/enrollmentErrors";

import type { MultisigEnrollmentSession } from "@/types";

/** `DELETE /multisig/enrollment`. Cancels the active session (any Owner); returns the cancelled session. */
export const useMultisigEnrollmentCancel = () => {
  const queryClient = useQueryClient();

  return useMutation<MultisigEnrollmentSession, EnrollmentError, void>({
    mutationFn: () =>
      enrollmentRequest<MultisigEnrollmentSession>(MULTISIG_ENROLLMENT_URL, {
        method: "DELETE",
      }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: MULTISIG_ENROLLMENT_QUERY_KEY }),
  });
};
